import { render } from "./Proyectos.vue?vue&type=template&id=698ac380&scoped=true"
import script from "./Proyectos.vue?vue&type=script&lang=js"
export * from "./Proyectos.vue?vue&type=script&lang=js"

import "./Proyectos.vue?vue&type=style&index=0&id=698ac380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698ac380"]])

export default __exports__